export default __webpack_public_path__ + "static/media/small-fire.4e888c52.svg";